import { z } from "zod";
import { ProjectsDTO } from "unnamed-contracts";
import {
  ProjectSummary as ProjectSummaryModel,
} from "unnamed-contracts/dist/models/project";
import type {
  Project as ContractProject,
  ProjectBootstrapPayload as ContractProjectBootstrapPayload,
} from "unnamed-contracts/dist/models/project";
import type {
  Page as ContractPage,
  PageSummary as ContractPageSummary,
} from "unnamed-contracts/dist/models/page";
import type {
  Sketch as ContractSketch,
  SketchStroke as ContractSketchStroke,
  SketchAnnotation as ContractSketchAnnotation,
} from "unnamed-contracts/dist/domain/sketch-types";
import type {
  SketchSummary as ContractSketchSummary,
  SketchOperation as ContractSketchOperation,
} from "unnamed-contracts/dist/models/sketch";

export type Project = ContractProject;
export type ProjectSummary = z.infer<typeof ProjectSummaryModel>;
export const ProjectSummarySchema = ProjectSummaryModel;
export type ProjectBootstrapPayload = ContractProjectBootstrapPayload;

export type Page = ContractPage;
export type PageSummary = ContractPageSummary;

export type Sketch = ContractSketch;
export type SketchSummary = ContractSketchSummary;
export type SketchStroke = ContractSketchStroke;
export type SketchAnnotation = ContractSketchAnnotation;
export type SketchOperation = ContractSketchOperation;

export type ProjectType = Project["projectType"];
export type AppLanguage = Project["appLanguages"] extends Array<infer Lang>
  ? Lang
  : string;

export const ProjectBootstrapResponseSchema =
  ProjectsDTO.ProjectBootstrapResponse;
export type ProjectBootstrapResponse = z.infer<
  typeof ProjectBootstrapResponseSchema
>;

export const ProjectPagesResponseSchema = ProjectsDTO.ProjectPagesResponse;
export type ProjectPagesResponse = z.infer<typeof ProjectPagesResponseSchema>;

export const ProjectPageResponseSchema = ProjectsDTO.ProjectPageResponse;
export type ProjectPageResponse = z.infer<typeof ProjectPageResponseSchema>;

export const ProjectSketchesResponseSchema =
  ProjectsDTO.ProjectSketchesResponse;
export type ProjectSketchesResponse = z.infer<
  typeof ProjectSketchesResponseSchema
>;

export const ProjectSketchResponseSchema = ProjectsDTO.ProjectSketchResponse;
export type ProjectSketchResponse = z.infer<
  typeof ProjectSketchResponseSchema
>;
